import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPageViewParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPageView";
import { getSettingsCollection } from "@toolkit/Framework/Store/Context/ContextSelectors";
import { useSelector } from "react-redux";

const useTrackPageView = (parameters: TrackPageViewParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    const hookParameters: TrackPageViewParameters = {
        client_id: ga.use.clientId(options),
        language: ga.use.language(options),
        page_type: ga.use.pageType(options),
        settingsCollection: useSelector((state: ApplicationState) => getSettingsCollection(state)),
        websiteName: useSelector((state: ApplicationState) => state.context.website.name),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        ...options,
    };

    return (parameters: Partial<TrackPageViewParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.pageView({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackPageView;
